import React from 'react';
import {view} from '@sail/ui';
import {message, useIntl} from '@sail/intl';
import {Button} from '../../SharedComponents';

const messages = {
  cancelLabel: message({
    id: 'connectEmbedLib.externalAccount.cancelLabel',
    description: 'Cancel button the external account verification form',
    defaultMessage: 'Cancel',
  }),

  nextLabel: message({
    id: 'connectEmbedLib.externalAccount.confirmLabel',
    description: 'Confirm button the external account verification form',
    defaultMessage: 'Confirm',
  }),
};

type Props = {
  sending: boolean;
  disabled: boolean;
  onSubmit?: () => void;
  onClose: () => void;
};

export const ExternalAccountConfirmationFooter = ({
  sending,
  disabled,
  onSubmit,
  onClose,
}: Props) => {
  const intl = useIntl();

  return (
    <view.div css={{stack: 'y', gap: 'space.150'}}>
      <Button
        type="primary"
        onPress={() => onSubmit && onSubmit()}
        behavior="submit"
        pending={sending}
        disabled={disabled}
        css={{width: 'fill'}}
        data-testid="external-account-confirmation-submit-button"
      >
        {intl.formatMessage(messages.nextLabel)}
      </Button>
      <Button onPress={onClose} disabled={sending} css={{width: 'fill'}}>
        {intl.formatMessage(messages.cancelLabel)}
      </Button>
    </view.div>
  );
};
